import axiosConfig from "../../axiosConfig";

//-------| Re-used Api |-------//
export const fetchHardCodeValues = async (queryParams) => {
  try {
    const res = await axiosConfig.get(`GetHardCodeValues`, {
      params: queryParams,
    });

    const data = res.data;
    return data;
  } catch (error) {
    console.error("Error hard-code value api:", error);
    throw error;
  }
};
